// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'attendances/archive',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-attendances" */ '@/pages/[organisation]/hr/team-member-attendances/archived-team-member-attendances.vue'),
        name: 'human-resource.team-member-attendances.archived-team-member-attendances',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.attendance.update-team-member-attendance',
        },
    },
    {
        path: 'attendances/archive/:attendanceId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-attendances" */ '@/pages/[organisation]/hr/team-member-attendances/archived-team-member-attendance/[id].vue'),
        name: 'human-resource.team-member-attendances.view-archived-team-member-attendance',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.attendance.update-team-member-attendance',
        },
    },

    {
        path: 'attendances',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-attendances" */ '@/pages/[organisation]/hr/team-member-attendances/team-member-attendances.vue'),
        name: 'human-resource.team-member-attendances.search-team-member-attendances',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.attendance.view-team-member-attendances',
        },
    },
    {
        path: 'attendances/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-attendances" */ '@/pages/[organisation]/hr/team-member-attendances/team-member-attendance/new.vue'),
        name: 'human-resource.team-member-attendances.create-team-member-attendance',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.attendance.create-team-member-attendance',
        },
    },
    {
        path: 'attendances/:attendanceId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-attendances" */ '@/pages/[organisation]/hr/team-member-attendances/team-member-attendance/[id].vue'),
        name: 'human-resource.team-member-attendances.view-team-member-attendance',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.attendance.view-team-member-attendances',
        },
    },
    {
        path: 'attendances/:attendanceId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-attendances" */ '@/pages/[organisation]/hr/team-member-attendances/team-member-attendance/[id]/edit.vue'),
        name: 'human-resource.team-member-attendances.update-team-member-attendance',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.attendance.update-team-member-attendance',
        },
    },
];
